import React, {
	useState,
	useEffect
} from 'react';
import {
	useSelector,
	//useDispatch,
} from 'react-redux';


import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Nav from 'react-bootstrap/Nav'
import logo from 'logo_landscape_white.png'
import { LoginModal } from 'pages/auth/login.js'
import { getUserGroupAuth } from 'pages/auth/actions.js'
import { UserProfileModal } from 'pages/auth/userProfile.js'
import { actionResetMessages } from 'components/messages/actions.js'
//import {
//	URL_AUTH_LOGIN,
//	URL_AUTH_LOGOUT
//} from 'services/urls.js'

import {
	//actionLoginUser,
	//actionLogoutUser,
	actionCognitoSignout,
	//clearUserCookies,
	//loadAuthFromCookies,
	//actionFetchTokens,
	actionRefreshTokens,
	//actionFetchAuthorisation,
	isSuperuser,
} from 'pages/auth/actions.js'

//import {
	//Link,
	//useLocation,
//} from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'
import { BANNER } from 'services/urls.js';


const StaffMenu = (props) => {

	//const { setModalProfileShow, setModalLoginShow } = props
	//const { setModalLoginShow } = props
	//const dispatch = useDispatch()
	//console.log('debug', props.currentUser['cognito:groups'])
	//console.log('found', props.currentUser['cognito:groups'].includes("superusers"))
	if (isSuperuser(props.currentUser)){
		return (
			<LinkContainer to="/staff">
				<Nav.Link href={"#"}>Staff</Nav.Link>
			</LinkContainer>
		)
	} else {
		return (
			null
		)
	}
}

const SessionManageMenu = (props) =>{
	const { currentUser, clientId, authorisation, } = props;

	if (getUserGroupAuth(currentUser, clientId, authorisation, 'admin')){
		return (
			<LinkContainer to="/manage/session">
			<Nav.Link href={"#"}>Manage Sessions</Nav.Link>
			</LinkContainer>
		)
	} else {// no authorisation
		return (
			<Nav.Link
				href={"#"}
				disabled
			>
				Manage Sessions
			</Nav.Link>
		)
	}
}

const Banner = (props) => {
	if (BANNER.length > 0){
		return (<Nav.Link><p style={{backgroundColor:'yellow',color: 'blue'}}>{ BANNER }</p></Nav.Link>)
	} else {
		return (null)
	}
}

const UserMenu = (props) => {
	const {
		username,
		//email
	} = props.currentUser
	//const { setModalProfileShow, setModalLoginShow } = props
	//const { setModalLoginShow } = props
	//const dispatch = useDispatch()
	//console.log('props.authLoading', props.authLoading);
	if (props.authLoading){
		return (null);
	} else {
		if (username.length > 3){
			return (
				<>
					<Nav.Link>{ username || 'unknown user' }</Nav.Link>
					{/* <Nav.Link onClick={() => setModalProfileShow(true)}>Profile</Nav.Link> */}
					{/* <Nav.Link onClick={() => actionLogoutUser() }>Logout</Nav.Link> */}
					<Nav.Link
						// { ...(props.authLoading && { disabled: true })}
						onClick={() => {
							//window.location.href = URL_AUTH_LOGOUT;
							//actionLogoutUser();
							actionCognitoSignout();
							return null;
						}}
					>Logout</Nav.Link>
				</>
			)
		} else {
			return (
				// <Nav.Link onClick={() => setModalLoginShow(true)}>Login</Nav.Link>
				<Nav.Link
					// { ...(props.authLoading && { disabled: true })}
					onClick={() => {
						//window.location.href = URL_AUTH_LOGIN;
						actionRefreshTokens();
						return null;
					}}
				>Login</Nav.Link>
			)
		}
	}
}

export const MenuBarMain = (props) => {

	const { showMenu } = props;
	const [modalLoginShow, setModalLoginShow] = useState(false);
	const [modalProfileShow, setModalProfileShow] = useState(false);
	//const dispatch = useDispatch()
	const currentUser = useSelector(state => state.currentUser);
	const clientId = useSelector(state => state.clientId);
	const authorisation = useSelector(state => state.authorisation);
	const authLoading = useSelector(state => state.authLoading);

	//console.log('clientId',clientId)
	//console.log('currentUser', currentUser)
	//console.log('authLoading', authLoading)
	// useEffect(() => {
	// 	console.log('menubar loads');
	// },[])
	//:UNDO:
	useEffect(() => {
		//console.log('currentUser.username', currentUser.username)
		//console.log('currentUser', currentUser)
		if (!authLoading && currentUser.username.length < 3){
			//console.log('menubar debug #1')
			//console.log('firing actionRefreshTokens() from menubar');
			actionRefreshTokens();
		}
	},[currentUser, authLoading])

	//const location = useLocation()
	return (
		<>
		<Navbar collapseOnSelect expand="lg" variant="dark">
			<Navbar.Brand href="#home">

			<img
				src = { logo }
				//width="300"
				height="30"
				className="d-inline-block align-top"
				alt="Optiweigh"
			/>

			</Navbar.Brand>


			<Navbar.Toggle aria-controls="responsive-navbar-nav" />
			{ showMenu &&
			<Navbar.Collapse id="responsive-navbar-nav">
				<Nav className="mr-auto">
					{/* <Nav.Link href="#features">Features</Nav.Link> */}
					<NavDropdown title="Reports" id="collasible-nav-dropdown">
						{/* <LinkContainer to="/report/animalsByDay">
							<NavDropdown.Item href="#">Animals by day</NavDropdown.Item>
						</LinkContainer> */}
						<LinkContainer to="/report/WeightChart">
							<NavDropdown.Item href = "/report/WeightChart">Weight chart</NavDropdown.Item>
						</LinkContainer>
						{/* <LinkContainer to="/report/distributionByWeek">
							<NavDropdown.Item href="#">Weight distribution</NavDropdown.Item>
						</LinkContainer> */}
						<LinkContainer to="/report/weightDistribution">
							<NavDropdown.Item href="#">Weight distribution</NavDropdown.Item>
						</LinkContainer>

						<LinkContainer to="/report/sessionData2">
							<NavDropdown.Item href="#">Session data</NavDropdown.Item>
						</LinkContainer>
						<LinkContainer to="/report/longTermData">
							<NavDropdown.Item href="#">Data over time</NavDropdown.Item>
						</LinkContainer>
						<NavDropdown.Divider />

					</NavDropdown>
					<SessionManageMenu
						currentUser = { currentUser }
						clientId = { clientId }
						authorisation = { authorisation }
					/>
					{/* <LinkContainer to="/manage/session">
						<Nav.Link href={"#"}>Manage Sessions</Nav.Link>
					</LinkContainer> */}
					{/* <Nav.Link><Link to = "/manage/session">Manage Sessions</Link></Nav.Link> */}
				</Nav>
				<Nav>
				{/* <Nav.Link><Link to = "/privacy">Privacy</Link></Nav.Link> */}
				<Banner />
				<UserMenu
					currentUser = { currentUser }
					authLoading = { authLoading }
					setModalProfileShow = { setModalProfileShow }
					setModalLoginShow = { setModalLoginShow }
				/>

				<StaffMenu
					currentUser = { currentUser }
				/>

				<LinkContainer to="/privacy">
					<Nav.Link href = "#">Privacy</Nav.Link>
				</LinkContainer>
				{/* <Nav.Link eventKey={2} href="#memes">
					Dank memes
				</Nav.Link> */}
				</Nav>

			</Navbar.Collapse>
}
		</Navbar>
		<LoginModal
			show = { modalLoginShow }
			onHide = { () => setModalLoginShow(false) }
			onShow = { actionResetMessages }
			//onShow = { () => console.log('onShow') }
		/>
		<UserProfileModal
			show = { modalProfileShow }
			onHide = { () => setModalProfileShow(false) }
			onShow = { () => actionResetMessages() }
		/>
		</>
	);
}